import type { AccountId } from '@atlassian/jira-shared-types/src/general.tsx';
// eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state
import type { Action } from '@atlassian/react-sweet-state';
import { set as userDismissSet } from '../../services/user-dismiss/index.tsx';
import type { State } from './types.tsx';

const set =
	(accountId: AccountId, hashId: string): Action<State> =>
	async ({ setState }) => {
		setState({
			error: null,
			isLoading: true,
			isSuccess: false,
		});

		try {
			await userDismissSet(accountId, hashId);
			setState({
				isSuccess: true,
			});
			// eslint-disable-next-line @typescript-eslint/no-explicit-any
		} catch (error: any) {
			setState({
				error,
			});
		} finally {
			setState({
				isLoading: false,
			});
		}
	};

export const actions = { set } as const;
